import Vue from "vue";
import vailcode from "@utils/errcode";
let generatePaymentInfo = (start, end, step = 1) => {
  return Array.from({ length: Math.floor((end - start) / step) + 1 }, (_, i) => `p_${start + i * step}`).reduce((acc, key) => {
    acc[key] = {
      paymentId: null,
      isLoading: false,
      timer: null,
    };
    return acc;
  }, {});
};

export default {
  namespaced: true,
  state: {
    taskInfo: {
      taskTimer: null,
      paymentInfo: generatePaymentInfo(0, 30),
      spinsPriceListLength: 0,
      popCoinAnim: {
        show: false,
        icon: "coin",
        reward: 5,
        endId: "coinBalanceId",
        userInfo: null,
        isEnd: false,
      },
      isCoinAnim: false,
    },
  },
  mutations: {},
  actions: {
    //每日签到 任务页面数据获取
    getDailySummary: async ({ state, commit }) => {
      return new Promise(async (resolve, reject) => {
        const res = await Vue.prototype.$http.post("/daily/summary", {});
        vailcode(res, () => {
          const data = res.data;
          if (!data) {
            resolve();
            return;
          }
          resolve(data.check_in);
        });
      });
    },
    //获取任务列表
    getTaskList: async ({ state, commit, dispatch }) => {
      return new Promise(async (resolve, reject) => {
        const res = await _v.$http.post("/task/list", {});
        console.log("resresresres", res);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            const tasks = {
              official: [],
              extra: [],
              onetime: [],
              daily: [],
            };
            data.map((item) => {
              _v.$set(item, "isLoading", false);
              _v.$set(item, "isCancelLoading", false);
              _v.$set(item, "type", item?.provider ? item.provider : item.type);
              let target = item.target;
              try {
                if (typeof item.target === "string" && item.target != "") {
                  target = JSON.parse(item.target);
                }
              } catch (e) {}
              _v.$set(item, "target", target);
              if (item.group_type == 3) {
                tasks.onetime.push(item);
              } else {
                tasks.daily.push(item);
              }
              // if (item.group_type == 0) {
              //   tasks.extra.push(item);
              // } else if(item.group_type == 1 || item.group_type == 2) {
              //   tasks.official.push(item);
              // }else if(item.group_type== 3) {
              //   tasks.onetime.push(item)
              // }else if(item.group_type==4) {
              //   tasks.daily.push(item)
              // }
            });
            console.log("taskstaskstaskstasks", tasks);
            resolve(tasks);
            console.log("datadatadata", data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //验证任务
    doTask: async ({ state, commit }, params) => {
      return new Promise(async (resolve, reject) => {
        console.log("params", params);
        const res = await Vue.prototype.$http.post("/task/complete", params);
        //   const res = {
        //     "code": 0,
        //     "message": "",
        //     "data": {
        //         "completeData": {
        //             "value": null
        //         },
        //         "userInfo": {
        //             "id": 2838778,
        //             "tg_id": "6605438145",
        //             "username": "wjm12345",
        //             "firstname": "wjm123",
        //             "lastname": "",
        //             "head_color": "#586c4c",
        //             "avatar_url": null,
        //             "invite_reward": 0,
        //             "ref_count": 0,
        //             "joined_wallet": 0,
        //             "coin": 5698,
        //             "stock": 0,
        //             "total_stock": 0,
        //             "spins": 10,
        //             "airdrop_ticket": 0,
        //             "ref_code": "FxHMZA",
        //             "user_level": 0,
        //             "user_group_id": null,
        //             "skin": "basic",
        //             "joined_twitter": 0,
        //             "joined_telegram": 0,
        //             "joined_channel": 0,
        //             "joined_discord": 0,
        //             "uid": "0x68 6391 8746 4562",
        //             "age": 1,
        //             "age_reward": 8000,
        //             "joined_facescan": 0,
        //             "premium_reward": 0,
        //             "ton_wallet": null,
        //             "ton_gas_paid": 0,
        //             "verified_premium": 0,
        //             "verified_face": 0,
        //             "verified_boost_channel": 0,
        //             "verified_with_appname": 0,
        //             "app_center_tickets": 0,
        //             "created_at": "2025-04-28 04:15:32",
        //             "user_group_name": ""
        //         },
        //         "taskInfo": {
        //             "id": 71,
        //             "title": "Upgrade 10 times every day",
        //             "icon": "https://static.humanpass.net/202504/30/436b3a78-00dc-4012-b2c3-0cfcdaaeb78f.png",
        //             "type": "validator",
        //             "is_official": 0,
        //             "reward": 1,
        //             "reward_stock": 0,
        //             "reward_spins": 0,
        //             "reward_token": 0,
        //             "reward_token_symbol": null,
        //             "url": " ",
        //             "target": "{\"type\":\"upgrade\",\"num\":10}",
        //             "sort": 0,
        //             "verifiable": 0,
        //             "completed_count": 5,
        //             "click_count": 0,
        //             "limit_count": 0,
        //             "status": 1,
        //             "check_countdown": 15,
        //             "check_countdown_prompt": null,
        //             "secondary_check_countdown": 15,
        //             "cyclical": 1,
        //             "cycle_interval": 1,
        //             "daily_limit_count": 1,
        //             "completed": 1,
        //             "countdown": 70137,
        //             "daily_completion_count": 1
        //         }
        //     }
        // }
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          (err) => {
            resolve(err);
          }
        );
      });
    },
    //支付前预处理任务
    getTaskPrepare: async ({ state, commit }, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await Vue.prototype.$http.post("/task/prepare", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //星星支付
    openInvoiceStarPay: async (_, params) => {
      return new Promise(async (resolve) => {
        const res = await _v.WebApp.openInvoice(params.url);
        async function invoiceClosedFnc(e) {
          _v.WebApp.offEvent("invoiceClosed", invoiceClosedFnc);
          console.log("ressssssss", res, e?.status);
          if (e?.status && e.status == "paid") {
            resolve(1);
          } else if (e?.status && e.status === "cancelled") {
            resolve();
          }
        }
        _v.WebApp.onEvent("invoiceClosed", invoiceClosedFnc);
      });
    },
    //获取每日签到列表
    getSignDailyTask: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await Vue.prototype.$http.post("/daily/steps", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },
    //每日签到 签到
    signDailyIn: async (_, params) => {
      return new Promise(async (resolve, reject) => {
        const res = await Vue.prototype.$http.post("/daily/complete", params);
        vailcode(
          res,
          () => {
            const data = res.data;
            if (!data) {
              resolve();
              return;
            }
            resolve(data);
          },
          () => {
            resolve();
          }
        );
      });
    },
  },
  getters: {
    isAnyPaymentSpinsLoading: (state) => {
      for (const key in state.taskInfo.paymentInfo) {
        if (state.taskInfo.paymentInfo[key].isLoading) {
          return true;
        }
      }
      return false;
    },
  },
};
